<template>
	<div class="animate_animated animate__slideInRight ">
    <div class="fixed w-full top-0 left-0 z-20">
			<div class=" bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
         <div class="h-1 bg-gradient-to-r from-[#ff6b6b] to-[#ffd6d6]"></div>
				<div class="flex items-center px-4 py-4">
					<div class="w-1/2">
						<div class="flex items-center w-full">
							<a  @click="$router.push('/')"><img src="@/assets/back-arrow.svg" alt=""></a>
							<span class="text-base text-content font-medium ml-4">Expiring Lease</span>
						</div>
					</div>
					<div class="w-1/2">
						<div class="flex items-center justify-end">
							<a @click="$router.push('searchexpiringlease')" class="text-main bg-slate-100 p-2.5 rounded-xl"><Filter class="size-5"/></a>
						</div>
					</div>
				</div>
				<div class="flex px-3 pb-3">
					<div class="flex items-strech w-full gap-2">
						<div class="relative w-full">
							<input type="text" @input="e => bsTerm = e.target.value" :value="bsTerm" name="" id="" placeholder="Search by Name"
								class="border border-inputBorder round-md p-3 w-full z-auto focus:outline-none rounded-xl">
							<button type="button" class="absolute right-0 top-0 m-3" v-if="bsTerm" @click="resetBs">
              <img src="@/assets/close-icon.svg" alt="" class="transform rotate-45"></button>
						</div>

						<div class="bg-primary px-4 flex items-center rounded-xl">
              <button type="button" :disabled="!bsTerm" @click="performBs">
							<img src="@/assets/search-icon-white.svg"   alt="" class=""></button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pt-20  bg-white mt-20">
			<div v-if="expAgreementLists.length === 0" class="text-center py-8 text-gray-500">
				No Records Found
			</div>
			<div v-else class="overflow-x-auto">
				<table class="min-w-full bg-white border border-gray-200">
					<thead class="bg-gray-50">
						<tr>
							<th v-for="column in columns" :key="column.field" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
								{{ column.label }}
							</th>
						</tr>
					</thead>
					<tbody class="bg-white divide-y divide-gray-200">
						<tr v-for="(row, index) in expAgreementLists" :key="index" class="hover:bg-gray-50">
							<td v-for="column in columns" :key="column.field" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
								<span v-if="column.field === 'agreement_till'">
									<span>{{ row.agreement_till }} <span class="text-red font-semibold text-xxs">{{ row.days_left }} day</span></span>
								</span>
								<span v-else-if="column.field === 'action'">
									<span class="text-primary cursor-pointer" @click="$router.push({ name: 'AgreementDetails', params: { uuid: row.uuid }})">view</span>
								</span>
								<span v-else>
									{{ row[column.field] || '' }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<Pagination 
			v-model="pageNo" 
			:total-pages="totalPages" 
			@update:modelValue="goToPage" 
		/>
	</div>
</template>
<script>
import {paramsFromQuery, prepareExpiringLeaseSearchParams} from '@/assets/scripts/utility.js';
import Pagination from '@/components/Common/Pagination.vue';
import Filter from '@/components/icons/Filter.vue';
export default {
  components: {
    Pagination,
    Filter
  },
  data() {
  return {
    bsTerm: this.$route.query.bs,
    total: 0,
    perPage: 0,
    agreements: [],
    advSearchParams: [],
    columns: [{
        label: 'Expiry Date',
        field: 'agreement_till',
        type: 'date',
        dateInputFormat: 'dd-MM-yyyy',
        dateOutputFormat: 'dd-MM-yyyy',
      },
      {
        label: 'Buyer',
        field: 'buyer_name',
        sortable: false,
      },
      {
        label: 'Type',
        field: 'transaction_type',
        sortable: false,
      },
      {
        label: 'Action',
        field: 'action',
        sortable: false,
      },
    ],
    expAgreementLists: [],
  };
},
watch: {
  $route(to, from){
    this.loadExpiringAgreements();
  }
},
created(){
  this.loadExpiringAgreements()
},
methods: {
  loadExpiringAgreements(){
    let queryP = {}
    if(Object.keys(this.advSParams).length > 0){
      queryP["as"] = true
      let searchParams = prepareExpiringLeaseSearchParams(this.advSParams);
      for(let key in searchParams){
        queryP[key] = searchParams[key];
      }
      this.advSearchParams = queryP
    } else {
      queryP["as"] = true
    }
    if (this.advSearchParams.length > 0){
      paramsFromQuery(queryP, this.advSearchParams);
    }
    else{
      paramsFromQuery(queryP, this.$route.query);
    }
    let data = this.$axios.get('/mobile_crm/agreements?expiring=true', {
      params: queryP
    })
    .then(res=>{
      this.expAgreementLists = res.data.agreements;
      this.perPage = res.data.per_page;
      this.total = res.data.count;
      // this.$store.dispatch('setAdvSParams', {});
  })
  .catch(err => console.log(err));
  },
  goToPage(pageNo){
    let newQ = {...this.$route.query, pageNo};
    this.$router.replace({query: newQ});
  },
  resetBs(){
    let rQ = this.$route.query
    this.bsTerm = ''
    if(rQ.bs){
      let {bs, ...newQ} = {}
      this.$router.replace({query: newQ})
    }
  },
  performBs(){
    if(this.bsTerm){
      let newQ = {...this.$route.query, bs: this.bsTerm}
      delete newQ.pageNo
      this.$router.replace({query: newQ})
    }
  }
},
computed: {
  advSParams(){
    return this.$store.getters.advSParams;
  },
  totalPages(){
    if(this.total === 0 || this.perPage === 0){
      return 0;
    }else{
      return Math.ceil(this.total/this.perPage);
    }
  },
  pageNo: {
    get(){
      let pageNo = this.$route.query.pageNo || 1
      return parseInt(pageNo);
    },
    set(){
      true;
    }
  },
  pageStart(){
    if(this.total === 0){
      return 0;
    }
    return (Math.max(0, (this.pageNo - 1)*this.perPage+1))
  },
  pageEnd(){
    if(this.total === 0){
      return 0;
    }
    return (Math.min(this.total, this.pageNo*this.perPage))
  }
}
}
</script>
<style scoped>

</style>